<template>
  <div class="contentArea_inner inner">
    <div class="descriptionArea inner">
      <p>
        <span>イベント参加者全員にメッセージを通知することができます。</span>
        <br />
        <span>メッセージは最後に送信した一件が表示されます。</span>
      </p>

      <h3>
        <span>アナウンスメッセージ入力</span>
      </h3>

      <validation-observer v-slot="{handleSubmit, invalid}">
        <form @submit.prevent="handleSubmit(sendNotice)">
          <validation-provider rules="required|max:3000" name="メッセージ">
            <textarea v-model="notice" placeholder="通知するメッセージを入力してください。" />
          </validation-provider>
          <div class="buttonArea">
            <button type="submit" class="btn" :disabled="invalid">送信</button>
          </div>
        </form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {Notice} from "socket_if"

export default {
  name: "Notice",
  data() {
    return {
      notice: null
    }
  },
  methods: {
    sendNotice() {
      this.$socket.dispatcher.emitNotice(
        new Notice({
          message: this.notice
        })
      )

      this.notice = null
      alert("アナウンスを送信しました。")
    }
  }
}
</script>
